var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"top-brands-wrap clearfix"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"top-brands clearfix"},_vm._l((_vm.topBrands),function(topBrand,index){return _c('a',{key:index,staticClass:"top-brand-image",attrs:{"href":topBrand.url}},[_c('img',{attrs:{"src":topBrand.logo.path,"alt":"brand logo"}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }